import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-input-clear',
  templateUrl: './input-clear.component.html',
  styleUrls: ['./input-clear.component.css']
})
export class InputClearComponent implements OnInit {


  //emits value
  @Output() valueChange = new EventEmitter<any>();

  //exposes 'fieldValue'
  @Input() value: string = '';

  @Input() placeholder: string = '';

  clear(){
    this.value = '';
    this.emit();
  }

  emit(){
    this.valueChange.emit(this.value);
  }

  constructor() { }

  ngOnInit(){ }

}
